import { Button, Modal, ModalBody, ModalContent, ModalFooter, ModalHeader, TmdxTextarea } from '@ds';
import { useState } from 'react';
import { IoClose } from 'react-icons/io5';
import { useBoolean } from 'react-use';
import { useCaseDetails } from '@/hooks/useCaseDetails';
import { MAX_LENGTH_2000 } from '@/constants/form.constants';

type QuoteRecallModalProps = {
  isOpen: boolean;
  onClose: () => void;
  onRecall: (caseId: string, comment: string) => Promise<void>;
};

export const QuoteRecallModal = ({ isOpen, onClose, onRecall }: QuoteRecallModalProps) => {
  const [comment, setComment] = useState('');
  const [isMutating, setIsMutating] = useBoolean(false);
  const { caseId } = useCaseDetails();

  const handleRecall = async () => {
    setIsMutating(true);
    await onRecall(caseId, comment);
    setIsMutating(false);
  };

  return (
    <Modal
      size="2xl"
      isOpen={isOpen}
      onClose={onClose}
      backdrop="opaque"
      closeButton={<IoClose size={45} style={{ top: 15, right: 15 }} />}
      classNames={{
        base: 'px-6',
        body: 'border-b-1 border-base-30 px-0 py-6 text-l-r',
        header: 'px-0 font-secondary text-hl! text-base-20',
        footer: 'px-0 flex gap-2',
        wrapper: 'z-420',
        backdrop: 'z-419',
      }}
    >
      <ModalContent>
        <ModalHeader>Recall Quote</ModalHeader>
        <ModalBody>
          <div className="text-m-m">
            You are about to recall the quote. Please provide an explanation. This explanation will be communicated to
            the TX Center.
          </div>
          <TmdxTextarea
            isRequired
            label="Recall comment"
            onValueChange={setComment}
            value={comment}
            maxLength={MAX_LENGTH_2000}
            errorMessage={
              comment.length > MAX_LENGTH_2000 ? `Comment must be less than ${MAX_LENGTH_2000} characters` : undefined
            }
            onClear={() => setComment('')}
          />
        </ModalBody>
        <ModalFooter>
          <Button size="md" variant="outline" onClick={onClose}>
            Cancel
          </Button>
          <Button
            isLoading={isMutating}
            isDisabled={!comment || comment.length > MAX_LENGTH_2000}
            size="md"
            color="default"
            variant="solid"
            onClick={handleRecall}
          >
            Confirm
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
